// src/config.js

const API_BASE_URL ="https://viewerslikeme.mpt.org/api";

export default API_BASE_URL;
